/**
 * @module use-cases/extended-captation/actions
 * @desc Extended Captation Action Creators
 *
 */
import { createAction } from 'core/use-cases/utilities';

export const goToHome = createAction<'goToHome'>('goToHome');

export const extendedCaptationNotAvailable = createAction<'extendedCaptationNotAvailable'>(
  'extendedCaptationNotAvailable',
);
